import GoBackButton from '@/common/components/GoBackButton';
import LogRequestShow from '@/common/components/LogRequestShow';
import { useParams } from 'react-router-dom';
import { useClientUser } from '../../hooks/useClientUser';

const ActionsHistoryShow = () => {
  const { id: userId } = useParams();

  const { data: clientUserData } = useClientUser({
    id: userId || '',
  });

  if (!userId) {
    return null;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-4 items-center">
          <GoBackButton
            fallback={`/users/${userId}/actionsHistory`}
            searchLastRouteFromReference={`/users/${userId}/actionsHistory`}
          />

          <h2 className="text-2xl font-bold">
            {clientUserData?.full_name}
          </h2>
        </div>
      </div>

      <div className="h-[calc(100vh-64px-32px-40px)]">
        <LogRequestShow />
      </div>
    </div>
  );
};

export default ActionsHistoryShow;
